import useResources from "../../../hooks/UseResources";
import * as InjuryClassService from "../../../services/InjuryClassService";

export default function useInjuryClasses() {
    return useResources(InjuryClassService.getAllInjuryClasses, "data");
}
